/*
 * @LastEditors: ttheitao
 * @Description: 搜索引擎
 * @FilePath: \onetab\src\store\searchEngines.ts
 * @Date: 2024-03-19 17:17:39
 * @LastEditTime: 2024-05-17 10:50:11
 * @Author: lisushuang
 */

import { reactive } from 'vue';
import { settings } from './settings';

export interface sEngine {
  name: string;
  url: string;
  icon: string;
  isActive: boolean;
  value:String
}

export const searchEngines = reactive({
  list: <Array<sEngine>>[
    {
      name: '百度',
      url: 'https://www.baidu.com/s?wd=',
      icon: require('../background/baidu_icon.png'),
      isActive: true,
      value:'baidu'
    },
    {
      name: 'Bing',
      url: 'https://cn.bing.com/search?q=',
      icon: 'https://www.bing.com/favicon.ico',
      isActive: false,
      value:'bing'
    },
    {
      name: '谷歌',
      url: 'https://www.google.com/search?q=',
      icon:  require('../background/google_icon.png'),
      isActive: false,
      value:'google'
    },
    {
      name: '雅虎',
      url: 'https://search.yahoo.com/search?p=',
      icon: require('../background/Yahoo_2019.svg'),
      isActive: false,
      value:'yahoo'
    },
    {
      name: 'DuckDuckGo',
      url: 'https://duckduckgo.com/?q=',
      icon: require('../background/DuckDuckGo_2023.svg'),
      isActive: false,
      value:'duckduckgo'
    },
    {
      name: 'Yandex',
      url: 'https://yandex.com/search/?text=',
      icon: 'https://yandex.com/favicon.ico',
      isActive: false,
      value:'yandex'
    },
    {
      name: '360搜索',
      url: 'https://www.so.com/s?q=',
      icon: 'https://www.so.com/favicon.ico',
      isActive: false,
      value:'so'
    },
    {
      name: '搜狗',
      url: 'https://www.sogou.com/sogou?query=',
      icon: 'https://www.sogou.com/favicon.ico',
      isActive: false,
      value:'sogou'
    },
  ], // {name:"",url:"",icon:"",isActive};

  getActive(): sEngine | null {
    return this.list.find((item) => item.isActive);
  },

  setActive(item: sEngine) {
    const active = this.getActive();
    if (active) active.isActive = false;
    this.list = this.list.map((i) => {
      if (i.name === item.name) {
        return { ...item, isActive: true };
      } else {
        return i;
      }
    });
  },

  goSearch(msg: string) {
    const engine = this.getActive();

    if (!engine) return;
    window['_paq'].push(['trackSiteSearch', msg, 'main', 0]);
    if (settings.searchOpenNew) {
      window.open(engine.url + msg);
    } else {
      window.location.href = engine.url + msg;
    }
  },
});
